import React from 'react';
import { VStack } from '@chakra-ui/react';

import { Field } from '../../types/shared/Vendor';
import { Market } from '../../types/shared/Market';
import { APP_FIELDS } from '../../support/shared/constants/Constants';
import { MarketEditView } from './MarketEditView';

function createEmptyMarketsField() {
  return {
    id: APP_FIELDS.ID_FIELD_MARKETS,
    name: '',
    value: [],
    dateSelectionByMarket: {},
  };
}

type Props = {
  markets: Array<Market>;
  fieldValue: Field | undefined;
  onChange: (newFieldValue: Field) => void;
};

export function MarketsEditView(props: Props) {
  const { onChange } = props;
  const fieldValue = props.fieldValue ?? createEmptyMarketsField();
  const markets = props.markets.filter((market) => !market.hidden);
  return (
    <VStack align="stretch" spacing={0} gap={5}>
      {markets.map((market) => {
        const dates = fieldValue.dateSelectionByMarket?.[market.id] ?? {};
        return (
          <MarketEditView
            key={market.id}
            market={market}
            dates={dates}
            onChange={(newDateSelection) => {
              // Remove this after we migrate everything to the new structure
              const dates = Object.keys(newDateSelection).filter(
                (date) => newDateSelection[date] === 'APPROVED',
              );
              // Remove this after we have better types for `value`
              const oldValue = Object(fieldValue.value);
              onChange({
                ...fieldValue,
                value: {
                  ...oldValue,
                  [market.id]: dates,
                },
                dateSelectionByMarket: {
                  ...fieldValue.dateSelectionByMarket,
                  [market.id]: newDateSelection,
                },
              });
            }}
          />
        );
      })}
    </VStack>
  );
}
